/* import __COLOCATED_TEMPLATE__ from './selected-flair.hbs'; */
import { tagName } from "@ember-decorators/component";
import SelectedNameComponent from "select-kit/components/selected-name";
const SelectedFlair = dt7948.c(class SelectedFlair extends SelectedNameComponent {}, [tagName("")]);
export default SelectedFlair;